import { ConfirmModal } from '../../../shared/modal'

type ConfirmCopyPublishedTemplatesModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmCopyPublishedTemplatesModal = ({
  isOpen,
  onConfirm
}: ConfirmCopyPublishedTemplatesModalProps) => (
  <ConfirmModal
    confirmText="Copy Templates"
    isOpen={isOpen}
    onConfirm={onConfirm}
    title="Copy Published Templates"
  >
    Are you sure you want to copy all published templates?
    <p>
      This action will create draft copies of all currently published templates. You will be able to
      edit these copies before publishing them again.
    </p>
  </ConfirmModal>
)

export default ConfirmCopyPublishedTemplatesModal
